import React from 'react';

import ErrorBoundary from '@swf/components/ErrorBoundary/ErrorBoundary';
import StarsWidget from '@swf/components/StarsWidget/StarsWidget';
import type { Section } from '@swf/core/types/Layout';
import layouts from '@swf/layouts/index';

const StarsSection: React.FC<Section> = ({ widgets, layout, component, preload = 0 }) => {
  let preloadCount = 0;
  return (
    <>
      {widgets?.map((config) => (
        <ErrorBoundary
          key={config.id}
          beforeCapture={(scope) => {
            scope.setTag('widget.id', config.id);
            scope.setTag('widget.name', config.meta.name);
          }}
        >
          <StarsWidget
            {...config}
            preload={
              preload === true ||
              (typeof preload === 'number' &&
                (!config.services ||
                  Object.values(config.services).find((service) => service.config.onLoad)) &&
                preloadCount++ < preload)
            }
          />
        </ErrorBoundary>
      ))}
      {layout &&
        React.createElement(
          layouts[layout.type] as unknown as React.ComponentType,
          layout as React.Attributes
        )}
      {component}
    </>
  );
};

export default StarsSection;
